// @ts-nocheck
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import { useMediaQuery, Box, Container, Toolbar } from '@mui/material';

// project import
import Drawer from './Drawer';
import Header from './Header';
import useConfig from 'hooks/useConfig';
import useMenu, { MenuProvider } from 'contexts/MenuContext';

// ==============================|| MAIN LAYOUT ||============================== //

// front-end's MainLayout, trimmed to what the partner dashboard uses (vertical drawer,
// header, content container) — no Ask AI, horizontal menu or business checks.
const MainLayoutShell = () => {
  const theme = useTheme();
  const matchDownXL = useMediaQuery(theme.breakpoints.down('xl'));
  const { container, miniDrawer } = useConfig();
  const { openDrawer } = useMenu();

  // set media wise responsive drawer
  useEffect(() => {
    if (!miniDrawer) {
      openDrawer(!matchDownXL);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [matchDownXL]);

  return (
    <Box sx={{ display: 'flex', width: '100%' }}>
      <Header />
      <Drawer />

      <Box component="main" sx={{ width: 'calc(100% - 260px)', flexGrow: 1, p: { xs: 1.25, sm: 2 } }}>
        <Toolbar />
        <Container
          maxWidth={container ? 'xl' : false}
          sx={{
            ...(container && {
              px: { xs: 0.5, sm: 1.25, lg: 1.75 },
              py: { xs: 1.25, sm: 2, lg: 4.5 }
            }),
            position: 'relative',
            minHeight: 'calc(100vh - 110px)',
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            maxWidth: container ? '1280px !important' : 'none'
          }}
        >
          <Outlet />
        </Container>
      </Box>
    </Box>
  );
};

const MainLayout = () => (
  <MenuProvider>
    <MainLayoutShell />
  </MenuProvider>
);

export default MainLayout;
